export default {
  base: {
    variant: 'spark.base.wrapper',
    width: '100%',
    appearance: 'none',
    p: 'base',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: 'grey-100',
    borderRadius: '0',
    fontFamily: 'base',
    fontSize: 'base',
    lineHeight: 'base',
    backgroundColor: 'grey-05',
    '&._spark_input_empty': {
      backgroundColor: 'grey-0'
    },
    '::placeholder': {
      color: 'grey-60'
    },
    '&:focus, ._force-focus &': {
      outline: 'none',
      boxShadow: function boxShadow(t) {
        return "0 0 0 2px ".concat(t.colors.secondary);
      }
    },
    '&._spark_input_left-element': {
      paddingLeft: '48px'
    },
    '&._spark_input_right-element': {
      paddingRight: '48px'
    }
  },
  variants: {
    basic: {
      variant: 'spark.element.input.base'
    },
    error: {
      variant: 'spark.element.input.base',
      boxShadow: function boxShadow(t) {
        return "0 0 0 2px ".concat(t.colors.error);
      }
    },
    success: {
      variant: 'spark.element.input.base',
      boxShadow: function boxShadow(t) {
        return "0 0 0 2px ".concat(t.colors.success);
      }
    }
  },
  container: {
    base: {
      display: 'block',
      position: 'relative'
    }
  },
  leftElement: {
    base: {
      position: 'absolute',
      top: '50%',
      left: 'base',
      transform: 'translateY(-50%)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '24px',
      width: '24px'
    }
  },
  rightElement: {
    base: {
      position: 'absolute',
      top: '50%',
      right: 'base',
      transform: 'translateY(-50%)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '24px',
      width: '24px'
    }
  }
};